import { CheckboxContainer } from "@components/inputs/checkbox/Checkbox.styles";
import styled from "styled-components";

import { T_PLAIN_big_hig } from "../../../global.style";


export const MonthCheckboxSelectorWrapper = styled.div<{
    $hideMasterCheckbox: boolean;
}>`
    display: grid;
    grid-template-columns: repeat(${props => props.$hideMasterCheckbox ? 12 : 13}, max-content);
    grid-template-rows: 1fr 1fr;
    gap: 10px;
    align-self: flex-start;
    
    ${CheckboxContainer} {
        justify-content: center;
    }
`;

export const Label = styled.strong`
    ${T_PLAIN_big_hig};
    display: block;
    text-align: center;
`;